import { render, staticRenderFns } from "./fccAbaBoletos.vue?vue&type=template&id=40b379ec"
import script from "./fccAbaBoletos.vue?vue&type=script&lang=js"
export * from "./fccAbaBoletos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports